import MaterialRateEdit from '@/components/material/rateedit/MaterialRateEdit.vue'
import MaterialEdit from '@/components/material/materialedit/MaterialEdit.vue';
import MaterialRateHistory from '@/components/material/ratehistory/MaterialRateHistory.vue';
import MaterialRateMultiEdit from '@/components/material/ratemultiedit/MaterialRateMultiEdit.vue';
import ClientMaterialGroupSettings from '@/components/client/materialgroupsettings/ClientMaterialGroupSettings.vue';
import PeriodicNameList from '@/components/configs/periodicname/list/PeriodicNameList.vue';

const defaultFilterValues = {
  displayTypes: ['ACTIVE'],
  isAllowed: [1],
  materialGroups: [],
  materialCategories: [],
  displayActiveNames: 1
};

export default {
  name: 'MaterialRatesList',
  props: ['value', 'clientApiId', 'client'],
  components: {
    MaterialRateEdit,
    MaterialRateHistory,
    MaterialEdit,
    MaterialRateMultiEdit,
    ClientMaterialGroupSettings,
    PeriodicNameList
  },
  data () {
    return {
      isMounted: false,
      currentReq: null,
      loading: true,
      materialRates: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues)
    };
  },
  computed: {
    activePeriodId () {
      if (this.filterValues.displayActiveNames == 1) {
        return this.ZPFormatHelper.getCurrentDatePeriodId();
      }
      return null;
    },
    tableHeaders () {
      const headers = [
        { key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name', class: 'col-width-medium' },
        { key: 'material_category_id', label: this.$t('material-category.title'), type: 'slot', slotcode: 'customtext', class: (this.canViewAllClients ? 'col-width-large' : ''), localFilter: true, searchFunc: this.getMaterialCategoryFilterTxt },
        { key: 'material_id', label: this.$t('material.title'), type: 'slot', slotcode: 'customtext', class: (this.canViewAllClients ? 'col-width-large' : ''), localFilter: true, searchFunc: this.getMaterialFilterTxt }
      ];
      if (this.clientApiId) {
        if (this.canViewAllClients) {
          headers.push({ key: 'defaultRate', label: this.$t('material.defaultRate'), format: 'formatDecimal', precision: 4 });
          headers.push({ key: 'clientRate', label: this.$t('material.clientRate'), format: 'formatDecimal', precision: 4 });
          headers.push({ key: 'discount', label: this.$t('material-group.discount'), format: 'formatPercent' });
          headers.push({ key: 'activeDiscount', label: this.$t('material.activeDiscount'), format: 'formatPercent' });
          headers.push({ key: 'isAllowed', label: this.$t('material_rate.isAllowed'), format: 'formatYesNo' });
          headers.push({ key: 'activeRate', label: this.$t('material.activeRate'), format: 'formatDecimal', precision: 4 });
          if (this.canEdit) {
            headers.push({ key: 'actions', label: '', actions: [{ label: this.$t('client.material-rates'), emit: 'viewRateHistory', bicon: 'list', class: 'btn-secondary' }] });
          }
        } else {
          headers.push({ key: 'activeRate', label: this.$t('material.rate'), format: 'formatDecimal', precision: 4 })
        }
      } else {
        headers.push({ key: 'measure_type_id', label: this.$t('material.measure_type'), format: 'formatFromConfig', configKey: 'measure_types', configParam: 'name' });
        headers.push({ key: 'autoApproveFilledInLast', label: this.$t('material.autoApproveFilledInLast'), format: 'formatLineOnEmpty' });
        headers.push({ key: 'disabled', label: this.$t('material.disabled'), format: 'formatYesNo' });
        headers.push({ key: 'from_date_period_id', label: this.$t('material-category.from_date_period_id'), format: 'formatDatePeriod' });
        headers.push({ key: 'to_date_period_id', label: this.$t('material-category.to_date_period_id'), format: 'formatDatePeriod' });
        headers.push({ key: 'order', label: this.$t('general.item.order') });
        headers.push({ key: 'active_rate.isAllowed', label: this.$t('material_rate.isAllowed'), format: 'formatYesNo' });
        headers.push({ key: 'active_rate.rate', label: this.$t('material.activeRate'), format: 'formatDecimal', precision: 4 });
        if (this.canEdit) {
          const actions = [
            { label: this.$t('menu.material.edit'), emit: 'editMaterial', icon: 'edit', bicon: 'pencil-fill' },
            { label: this.$t('menu.material.delete'), emit: 'deleteMaterial', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
            { label: this.$t('menu.material.restore'), emit: 'restoreMaterial', icon: 'restore', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
          ];
          headers.push({ key: 'actions', label: '', actions: actions });
        }
      }

      return headers;
    },
    tableExpandConfig () {
      if (this.canViewAllClients) {
        return { component: 'slot' }
      }
      return null;
    },
    materialClassId () {
      return this.$store.getters.getDataFromConfigById('model_classes', 'materials');
    },
    tableFilterConfig () {
      const filters = { };
      filters.materialGroups = { type: 'checkbox', label: this.$t('material-group.title'), options: this.materialGroupOptions };
      if (!this.clientApiId) {
        filters.isAllowed = { type: 'checkbox', label: this.$t('material_rate.isAllowed'), options: this.yesNoOptions };
        filters.displayTypes = { type: 'checkbox', label: this.$t('general.filters.display'), options: this.displayTypesOpions };
        filters.materialCategories = {
          type: 'searchchecklist',
          label: this.$t('material-category.title'),
          elname: 'material-category',
          nameParam: 'text',
          keyParam: 'code',
          options: this.materialCategoryOptions,
          class: 'col-sm-8'
        };
      }
      filters.displayActiveNames = { type: 'radio', label: this.$t('material.displayActiveNames'), options: this.yesNoOptions };
      return filters;
    },
    filterActions () {
      let actions = { filters: true, reload: false, download: true };
      if (this.clientApiId) {
        actions = { download: true };
      } else if (this.canEdit) {
        actions.add = { title: this.$t('menu.material.new') }
      }
      if (this.canEdit) {
        actions.extra = [
          { title: this.$t('menu.material.multi-edit'), class: 'btn-secondary', event: 'editMulti', icon: 'list-check' }
        ];
        if (this.client) {
          actions.extra.push({ title: this.$t('material-group.discounts'), class: 'btn-primary', event: 'editDiscounts', icon: 'percent' })
        }
      }
      return actions;
    },
    displayTypesOpions () {
      return [
        { code: 'ACTIVE', text: this.$t('general.filters.active') },
        { code: 'INACTIVE', text: this.$t('general.filters.inactive') },
        { code: 'DELETED', text: this.$t('general.filters.deleted') }
      ];
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    materialCategoryOptions () {
      return this.$store.getters.getConfigOptions('material_categories', this.$i18n.locale);
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale);
    },
    canViewAllClients () {
      if (this.ApiRequest.userHasPermission('view-clients')) {
        return true;
      }
      return false;
    },
    canEdit () {
      if (this.clientApiId) {
        return this.ApiRequest.userHasPermission('edit-clients');
      }
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      const reqData = {};
      for (const key of Object.keys(this.tableFilterConfig)) {
        if (typeof (this.filterValues[key]) === 'object' && this.filterValues[key].length > 0) {
          if (key === 'materialCategories') {
            reqData[key] = this.filterValues[key].map(val => val.code);
          } else {
            reqData[key] = this.filterValues[key];
          }
        }
      }

      const self = this;
      let path = 'material/material/list';
      if (this.clientApiId) {
        path = 'client/single/' + this.clientApiId + '/material-rates'
      }
      this.loading = true;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, reqData, function (response) {
        if (response.data) {
          self.materialRates = response.data;
          self.loading = false;
        }
      });
    },
    viewRateHistory (rate) {
      this.$refs.materialRateHistory.show(rate.material_id, this.clientApiId);
    },
    editMaterialRate (rate) {
      this.$refs.materialRateEdit.show(rate);
    },
    reloadTable () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },
    materialRatesUpdated () {
      this.$emit('saved');
      this.reloadTable();
    },
    materialsUpdated () {
      this.$emit('saved');
      this.$store.dispatch('loadConfig');
      this.reloadTable();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.reloadTable();
      }
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    editMaterial (el) {
      this.$refs.materialEdit.show(el);
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('material/material/deleted', this.ApiRequest.REQUEST_POST, { code: el.code, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.materialsUpdated();
        }
      });
    },
    deleteMaterial (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('material.deleteTitle'), this.$t('material.deleteMessage', { materialName: this.BasicHelper.getTranslation(el.name) }))
      }
    },
    restoreMaterial (el) {
      this.setDeleted(el, 0);
    },
    editMulti () {
      this.$refs.materialRateMultiEdit.show();
    },
    downloadTable (tableHtml) {
      const tableData = {
        materials: tableHtml
      }
      this.BasicHelper.tablesToExcelFile(tableData, 'Materiali_' + (new Date()).toISOString());
    },
    editDiscounts () {
      this.$refs.discountEditFrm.showDiscountList();
    },
    discountsUpdated (data) {
      this.$emit('discountsUpdated', data);
      this.getTableData()
    },
    getMaterialFilterTxt (text, el) {
      return this.ZPFormatHelper.getConfigValuePeriod('materials', 'id', el.material_id, 'name', true, this.activePeriodId);
    },
    getMaterialCategoryFilterTxt (text, el) {
      const parentId = this.$store.getters.getParamFromConfigByFilter('material_categories', 'id', el.material_category_id, 'parent_category_id');
      let txt = '';
      if (parentId) {
        txt = this.ZPFormatHelper.getConfigValuePeriod('material_categories', 'id', parentId, 'name', true, this.activePeriodId) + ', ';
      }
      return txt + this.ZPFormatHelper.getConfigValuePeriod('material_categories', 'id', el.material_category_id, 'name', true, this.activePeriodId);
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
    this.getTableData();
  }
}
